import { render, staticRenderFns } from "./PopupChatWindow.vue?vue&type=template&id=d1663b3a&scoped=true"
import script from "./PopupChatWindow.vue?vue&type=script&lang=js"
export * from "./PopupChatWindow.vue?vue&type=script&lang=js"
import style0 from "./PopupChatWindow.vue?vue&type=style&index=0&id=d1663b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1663b3a",
  null
  
)

export default component.exports